import {
  Box,
  Container,
  HStack,
  Button,
  Spacer,
  Text,
  BoxProps,
  useColorModeValue,
} from "@chakra-ui/react";
import useCaminoStore from "hooks/useCaminoStore";
import { API_ROUTES, SHARED_ROUTES } from "definitions/constants/routeConstants";
import apiClient from "services/ApiClient";
import { User } from "features/User/models";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";

function ImpersonatingBanner() {
  const setValue = useCaminoStore((state) => state.setValue);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleClick = async () => {
    const { company, ...user } = await apiClient.delete<User>(API_ROUTES.admin.users.impersonations.base);
    queryClient.clear();
    setValue({
      currentUser: user,
      currentCompany: company,
      currentRole: user.permission[0],
      isImpersonating: false,
    });
    navigate(SHARED_ROUTES.home);
  };

  return (
    <HStack
      bg="cdsOrange.500"
      color="text.warning"
      fontSize="sm"
      fontWeight="bold"
      px="2"
      py="1"
      rounded="md"
      textTransform="uppercase"
      width="100%"
    >
      <Text>Impersonating User</Text>
      <Spacer />
      <Button onClick={handleClick}>Stop Impersonating</Button>
    </HStack>
  );
}

function Navbar({ ...rest }: BoxProps) {
  const isImpersonating = useCaminoStore((state) => state.isImpersonating);
  const bgColor = useColorModeValue("creamBg.opacity10", "gray.500");

  return (
    <Box as="section" bg={bgColor} {...rest}>
      <Container ml="0">
        {isImpersonating && <ImpersonatingBanner />}
      </Container>
    </Box>
  );
}

export default Navbar;
